// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-method-promo {\n  margin-bottom: 12px;\n}\n.payment-method-promo.ant-list-vertical .ant-list-item-meta {\n  margin-bottom: 0;\n}\n.payment-method-promo.ant-list-vertical .ant-list-item-meta-title {\n  margin-bottom: 0;\n}\n.payment-method-promo.ant-list-vertical .ant-list-item {\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
